import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { History } from '../../history/history';

@Component({
  selector: 'app-history-event',
  templateUrl: './history-event.component.html',
  styleUrls: ['./history-event.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoryEventComponent {
  @Input() set historyEvent(event: History | undefined) {
    if (!event) {
      return;
    }
    this.subject = event.subject || '-';
    this.user =
      event.nomeUtente && event.cognomeUtente
        ? `${event.nomeUtente} ${event.cognomeUtente} `
        : '-';
    this.channel = event.channel || '-';
    this.description = event.body || '-';
    this.role = event.ruoloUtente?.[0] || '-';
    this.icon = event.iconName || '';
    this.date = event.dataEvento || '';
  }
  @Input() index = 0;
  @Input() set length(l: number | undefined) {
    this._length = l || 0;
  }
  private _length: number = 0;
  get length(): number {
    return this._length || 0;
  }

  subject = '';
  user = '';
  channel = '';
  description = '';
  role = '';
  icon = '';
  date = '';
}
